import React, { useEffect } from "react";
import {
  getAccessTokenEndpoint,
  getForgeRockToken,
  getRefreshTokenEndpoint,
  manageUserData,
} from "../service/api";
import jwt_decode from "jwt-decode";

function Login2(props) {
  const codeResponse = getParameterByName("code");
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  useEffect(() => {
    getToken();
    getUserAccessInfoToken();
  }, []);

  async function getToken() {
    localStorage.clear();
    const accessTokenResponse = await getAccessTokenEndpoint(codeResponse);         
    console.log("--->", accessTokenResponse);
    const accessTokenResponseData = accessTokenResponse?.data;
    if(accessTokenResponseData) {
      localStorage.setItem("bearerToken", accessTokenResponseData?.access_token);
      localStorage.setItem("userToken", accessTokenResponseData?.id_token);
      localStorage.setItem("refreshToken", accessTokenResponseData?.refresh_token);
    }

    const usertoken = accessTokenResponseData?.id_token;
    const userInfo = jwt_decode(usertoken);
    console.log(userInfo);
    const customAttributes = userInfo?.custom_attributes;
    if(customAttributes) {
      localStorage.setItem("dealerCode", customAttributes?.dealerCode);
      localStorage.setItem("userName", customAttributes?.firstName+''+customAttributes?.lastName);
      localStorage.setItem("firstName", customAttributes?.firstName);
      localStorage.setItem("lastName", customAttributes?.lastName);
      localStorage.setItem("KintoID", customAttributes?.kintoId);
      localStorage.setItem("tenantId", customAttributes.tenantId ? customAttributes.tenantId : "t001") ;
      localStorage.setItem("userRole", customAttributes?.dealerRole);
      localStorage.setItem("email", customAttributes?.email);
    }
    localStorage.setItem("userId", 'NA');
    let resp = await getForgeRockToken();  
    console.log("forgerock", resp);
    localStorage.setItem("ESGToken", resp?.data?.forgeRockToken);
    localStorage.setItem("dealerName", userInfo.custom_attributes.dealerName);
    manageUserData("Stratus");
    props.history.push("/grounded");
  }

 async function getUserAccessInfoToken() {
    setInterval(async () => {
      const refreshTokenResponse = await getRefreshTokenEndpoint();
      const accessTokenData = refreshTokenResponse?.data
      if (accessTokenData) localStorage.setItem("bearerToken", accessTokenData?.access_token);
      const forgeRockToken = await getForgeRockToken();
      const forgeRockTokenData = forgeRockToken?.data;
      if(forgeRockTokenData) localStorage.setItem("ESGToken", forgeRockTokenData?.forgeRockToken);
    }, 540000);
  } 
  return <div></div>;
}

export default Login2;
